import { getBrandedTitle } from "../../helpers/BrandingHelper";
import { lazy, Suspense, useContext, useEffect, useRef, useState } from "react";
import loaderContext from "../../context/loader/LoaderContext";
import studyviewerContext from "../../context/studyviewer/StudyviewerContext";
import userContext from "../../context/users/UserContext";
import ViewportContext from "../../context/studyviewer/ViewportContext";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import toastContext from "../../context/toast/ToastContext";
import { initialize, purgeCache, getAugToolGroup, setPreferGpuRendering } from "./helpers/CornerstoneService";
import {
  registerOpenViewer,
  getOpenViewerCount,
  OPEN_VIEWER_WARN_THRESHOLD,
} from "./helpers/OpenViewerRegistry";
import { handleMultiFrameShortcut } from "./helpers/multiFrameShortcuts";
import {
  useAnySeriesExpanded,
  setAutoExpandCineSeries,
  resetSeriesPanelState,
} from "./helpers/seriesPanelStore";
import { resetInstanceTiles } from "./helpers/CornerstoneThumbnailService";
import { userPreference } from "../../service/UserService";
import {
  resetVOILUTRange,
  setVOILUTRange,
} from "./helpers/WindowLevelUtility";

import {
  setInvert,
  FlipHorizontally,
  FlipVertically,
  loadAIImages,
  resizeViewport,
  performResize,
  getViewport,
  stepMixedSeriesInstance,
  setToolOnActiveMPRViewport,
  setToolOnActiveViewport,
} from "./helpers/CornerstoneViewportService";
import AlertSuccessModal from "../../components/AlertSuccessModal/AlertSuccessModal";
import ConfirmAlertModal from "../../components/ConfirmAlertModal/ConfirmAlertModal";
import CommunicationModal from "../Communication/CommunicationModal";
import TopBar from "./Components/TopBar";
import Annotations from "../Annotations/Annotations";
import ThumbnailList from "./Components/Thumbnail/ThumbnailList";
import NewReport from "../Report/NewReport";
import ViewportLayout from "./Components/Viewport/ViewportLayout";
import {
  LATERAL_VIEW_MODALITY_LIST,
  USERTYPES,
  SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST,
  showPathologyForModalities,
  NONXRAYMODALITIES,
  DEFAULT_TOOL,
  NonAuthRoutes,
  CONSTRUCTABLE_MODALITIES,
} from "../../constants/Constants";
import {
  AngleTool,
  CobbAngleTool,
  PanTool,
  StackScrollTool,
  WindowLevelTool,
  ZoomTool,
} from "@cornerstonejs/tools";
import { isMobile } from "react-device-detect";
import {
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import themeContext from "../../context/theme/ThemeContext";
import ContextMenu from "./helpers/ContextMenu";
import ThumbnailContext from "../../context/studyviewer/ThumbnailContext";
import Impressions from "./Components/Overlays/Impressions";
import NotAllowed from "../../components/NotAllowed";
import RSNAModal from "../Report/components/ReportModals/RSNAModal/RSNAModal";
import SubmitTick from "./Components/SubmitTick/SubmitTick";
import SuspectIcon from "./Components/SuspectIcon/SuspectIcon";
import { t } from "i18next";
import CustomToolTipHost from "../../components/CustomToolTipHost/CustomToolTipHost";
import ViewerStartToast from "../../components/Toast/ViewerStartToast";
const MobileViewer = isMobile ? lazy(() => import("./MobileViewer")) : null;
import ShortcutKeyModal from "./Components/ShortcutKeyModal/ShortcutKeyModal";
import CalibrationModal from "./Components/CalibrationModal";
import SeriesStackScrollMouseWheelTool from "./helpers/SeriesStackScrollMouseWheelTool";
import MobileViewerContext from "../../context/studyviewer/MobileViewerContext"; // adjust path if needed
import AccountWarningModal from "../../components/AccountWarningModal";
import { getEnv } from "../../helpers/EnvHelper";

const Viewer = (props) => {
  var gf_location = "";
  const [cornerstoneInitialized, setCornerstoneInitialized] = useState(false);
  // const [showPathologyOptions, setShowPathologyOptions] = useState(
  //   (isMobile || import.meta.env.VITE_VDC_PLATFORM=="true")? false : true
  // );

  const [pathologyOptionOpened, setPathologyOptionOpened] = useState(true);
  const [documentTitle, setDocumentTitle] = useState(null);
  const [windowHeight] = useState(window.innerHeight * 0.88);
   const [initialVOIRange, setInitialVOIRange] = useState({});
   
  const { studyId } = useParams();
  const [searchParams] = useSearchParams();
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const location = useLocation();
  const widgetOpen = location.state?.widgetOpen ?? null;
  const {
    assignmentData,
    setConfirmAlertModal,
    qcData,
    fetchStudyData,
    studyData,
    studyResponseData,
    priorStudyResponseData,
    studyModality,
    keyImages,
    dataGathered,
    thumbnailLoaded,
    studyParentId,
    setMessageCount,
    messageCount,
    fetchPriorStudyData,
    priorStudyData,
    patientStudyData,
    isAccessAllowed,
    notAllowedMessage,
    firmViewerId,
    setFirmViewerId,
    autoOpenReportPanel,
    parentChildReportsObj,
    extReportRecieved,
    aiProcessed,
    viewerOpacity,
    setViewerOpacity,
    showStartAlertToast,
    showStudyExpirationPopup,
    showStudyAlreadyExpiredPopup,
    isOutlineEnabled,
    isHeatMapEnabled,
    setIsOutlineEnabled,
    setIsHeatMapEnabled,
    showShortcutModal,
    showPathologyOptions,
    setShowPathologyOptions,
    showTopBar,
    isLandscape,
    maskImages,
    studyClinicalNotesData,
    autoGenerateReportData,
    reportMenu, setReportMenu,
    seriesMenu, setSeriesMenu,
    showAccountWarning,
    setShowAccountWarning,
    accountWarningText,
    showAiResult,
    showSavedReport,
    keyImagePresent,
  } = useContext(studyviewerContext);
  const { roles, username, privilegedFirmDoctor } =
    useContext(userContext);
  const {
    annotationData,
    activeViewportIndex,
    annotationDataAI,
    allTextToolAnnotation,
    changeLayout,
    isMPRActive,
    contextMenuOpen,
    isCompareActive,
    allowAddingTextAnnotation,
    showPriorStudyTopBar,
    imageLoadedOnViewport,
    viewportSeriesData,
    activeTool,
    setActiveTool,
    activeMPRTool,
    handleDefaultToolChange,
    setPreviousActiveTool,
    setPreviousActiveMPRTool,
    sharedViewer,
    seriesScrollCallback,
    viewportOldState,
    activeMPRViewportIndex,
    setActiveMPRTool,
    setActiveImageMaskToogle,
    removeSelectedMeasurement,
    removeAllMeasurements,
    mouseButtonToolAssignments,
    togglePrimaryMouseAssignmentForTool,
  } = useContext(ViewportContext);
  const {
    activeThumbnailIndex,
    activeStudyId,
    setStackScrollActiveThumbnailIndex,
  } = useContext(ThumbnailContext);
  const {
    hideCommnunicationModal,
    showCommunicationModal,
    lockStudy,
    checkIfCancelOrNot,
    getData,
    alertSuccessModal,
    confirmAlertModal,
    hideAlertSuccessModal,
    isClientReportExist,
    openRSNAModal,
    RSNAModalContent,
    setOpenRSNAModal,
    regenerateClick,
    showSubmitTick,
    showSuspectIcon,
    disableSave,
    disableSubmit,
    setDisableSave,
    setDisableSubmit,
    isWordFilePath,
    setFirmId,
    setMaskImages: setReportMaskImages,
    setStudyClinicalNotesData: setReportClinicalNotes,
    setIsNormalStudy: setReportIsNormalStudy,
    setStudyPatientDetails,
    setKeyImagePresentStudyList,
  } = useContext(studyReportContext);

  // Bridge the authoritative backend key-image flag from the viewer context
  // into StudyReportState (same value the study list pushes), so the report
  // editor's download/preview menus highlight consistently.
  useEffect(() => {
    setKeyImagePresentStudyList(keyImagePresent === true);
  }, [keyImagePresent]);

  const [isTabFocused, setIsTabFocused] = useState(false);
  const { setSlideReportOpen } = useContext(MobileViewerContext);
  const { showToastv2 } = useContext(toastContext);


  useEffect(() => {
    setFirmViewerId(NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER === window.location.pathname ?-2 :searchParams.get("firmId"));
  }, []);

  // Track how many study viewers are open across tabs and warn once if it gets
  // high. Each tab holds a WebGL context and the browser caps live contexts
  // (~16/process); past that, viewports go blank. This can't be fixed in app
  // code, so we warn the user to close some studies before that happens.
  useEffect(() => {
    const unregister = registerOpenViewer();
    let warned = false;
    let cancelled = false;
    // OLD: const checkCount = () => {
    // OLD:   if (warned) return;
    // OLD:   const count = getOpenViewerCount();
    // NEW: the count now comes from the browser's Web Locks (async); null = unavailable.
    const checkCount = async () => {
      if (warned) return;
      const count = await getOpenViewerCount();
      if (cancelled || count == null) return;
      if (count > OPEN_VIEWER_WARN_THRESHOLD) {
        warned = true;
        // Logged-only for now (no user-facing toast). The browser caps live
        // WebGL contexts (~16/process); with many studies open, viewports can
        // go blank.
        console.warn(
          `[Viewer] ${count} study viewers open across tabs (threshold ${OPEN_VIEWER_WARN_THRESHOLD}). ` +
            "Browser WebGL context limit (~16/process) may cause blank viewports."
        );
      }
    };
    checkCount();
    const intervalId = setInterval(checkCount, 4000);
    return () => {
      cancelled = true;
      clearInterval(intervalId);
      unregister();
    };
  }, []);

  // A study opened via ctrl+click is laid out / first-rendered while its tab is
  // backgrounded; the viewport can get fit to a wrong canvas size, so on first
  // focus the image looks flattened. Re-fit ONCE on the first time the tab
  // becomes visible — NOT on every visibility change (subsequent focuses don't
  // re-flatten, and resizing each time would flicker/waste work). performResize
  // preserves each viewport's pan/zoom (stores/restores position presentations),
  // so this one-time correction is non-destructive. Retried to cover the engine
  // build + first image render completing after the visibilitychange event.
  // ── Series panel per-instance view ──────────────────────────────────────
  // Widen the panel (two tiles per row) while a series is expanded — but not
  // while the report pane is open: there the grid stays one column at 150px.
  const anySeriesExpanded = useAnySeriesExpanded();
  const wideSeriesPanel = !isMobile && anySeriesExpanded && !reportMenu;

  // "Auto-expand series with cine clips" preference: load once per viewer
  // (the store's default — on — covers the moments before it returns and
  // routes without a regular login, where the call is skipped). Per-study
  // expand state is dropped when the viewer unmounts.
  useEffect(() => {
    if (NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER !== window.location.pathname) {
      userPreference()
        .then((res) => {
          const pref = res?.status === 200 ? res.data?.data?.userPreference : null;
          if (pref) setAutoExpandCineSeries(!!pref.autoExpandCineSeries);
        })
        .catch(() => { /* keep the current value */ });
    }
    return () => {
      resetSeriesPanelState();
      resetInstanceTiles();
    };
  }, []);

  const focusResizeDoneRef = useRef(false);
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState !== "visible") return;
      if (focusResizeDoneRef.current) return;
      focusResizeDoneRef.current = true;
      document.removeEventListener("visibilitychange", onVisible);
      [150, 600, 1500].forEach((delay) => {
        setTimeout(() => {
          try {
            const r = performResize();
            if (r && typeof r.catch === "function") r.catch(() => {});
          } catch (_) { /* non-fatal */ }
        }, delay);
      });
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, []);

  useEffect(() => {
    if(NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER === window.location.pathname && assignmentData.firmId !== null){
      setFirmId(assignmentData.firmId);
      setFirmViewerId(assignmentData.firmId);
    }
  }, [assignmentData.firmId]);

  // Sync viewer data into StudyReportState so the report panel can access it
  useEffect(() => {
    setReportMaskImages(maskImages);
  }, [maskImages]);

  useEffect(() => {
    if (studyClinicalNotesData) {
      setReportClinicalNotes(studyClinicalNotesData);
    }
  }, [studyClinicalNotesData]);

  useEffect(() => {
    setReportIsNormalStudy(autoGenerateReportData?.maxAIEmergency == 1);
  }, [autoGenerateReportData?.maxAIEmergency]);

  useEffect(() => {
    if (patientStudyData?.patientName || patientStudyData?.patientId) {
      setStudyPatientDetails({
        patientName: patientStudyData.patientName,
        patientId: patientStudyData.patientId,
      });
    }
  }, [patientStudyData?.patientName, patientStudyData?.patientId]);

  useEffect(() => {
    if (messageCount > 0) {
      //setShowCommunicationModal(true);
    }
  }, [messageCount]);

  useEffect(() => {
    const handleWindowResize = () => {
      setTimeout(() => {
        resizeViewport();
      }, 300);
    };
    if (cornerstoneInitialized && dataGathered && thumbnailLoaded) {
      window.addEventListener("resize", handleWindowResize);

      return () => {
        window.removeEventListener("resize", handleWindowResize);
      };
    }
  }, [cornerstoneInitialized, thumbnailLoaded, dataGathered]);
  
  useEffect(() =>{
    document.documentElement.style.setProperty( '--viewer-smart-tag-header', isLandscape ? '14%' : '5%' );
  },[isLandscape]);

  const setSeriesStackScrollConfig = (toolGroupManager) => {
    const seriesStackScrollConfig = toolGroupManager.getToolConfiguration(SeriesStackScrollMouseWheelTool.toolName);
    const seriesStackScrollMergedConfig = { ...seriesStackScrollConfig.configuration, seriesScrollCallback };
    toolGroupManager.setToolConfiguration(SeriesStackScrollMouseWheelTool.toolName,seriesStackScrollMergedConfig, true);
  }

  const initializeCornerstone = async () => {
    try {
      await initialize(seriesScrollCallback);
      setCornerstoneInitialized(true);
      //const toolGroup = getAugToolGroup();
      //setSeriesStackScrollConfig(toolGroup);
    } catch (error) {
      console.log(error);
      window.alert(
        "Viewer is unable to perform the action. Refresh the page to try again. If the issue persists, connect with the support team."
      );
    }
  };

  const getStudyData = async () => {
    if (!dataGathered) {
      setLoaderRunning(true);
      ref.current.continuousStart();
      await fetchStudyData(studyId, true);
    }
  };

  useEffect(() => {
    if (!isAccessAllowed) {
      ref.current.complete();
    }
  }, [isAccessAllowed]);

  const getPriorStudyData = async () => {
    if (!dataGathered) {
      setLoaderRunning(true);
      ref.current.continuousStart();
      await fetchPriorStudyData(studyId);
    }
  };

  const callAPIs = async () => {
    if (!cornerstoneInitialized) {
      await initializeCornerstone(0);
    }
    // const response = await userPreference();
    // if (response.status === 200) {
    //   setAdvViewerUser(response.data.data.advViewerUser);
    //   setUserPreferenceResponse(response.data.data.userPreference);
    // }
    if (props.priors) {
      await getPriorStudyData();
    } else {
      await getStudyData();
    }
    setLoaderRunning(false);
    ref.current.complete();
  };

  const fetchAIImages = async () => {
    if (!props.priors && NONXRAYMODALITIES.includes(studyModality)) {
      studyData.heatmapStacks.forEach(async (data) => {
        await loadAIImages(data.imageIds);
      });
      studyData.outlineStacks.forEach(async (data) => {
        await loadAIImages(data.imageIds);
      });
    } else {
      priorStudyData.forEach(async (studyData) => {
        studyData.heatmapStacks.forEach(async (data) => {
          if (NONXRAYMODALITIES.includes(data.modality))
            await loadAIImages(data.imageIds);
        });
        studyData.outlineStacks.forEach(async (data) => {
          if (NONXRAYMODALITIES.includes(data.modality))
            await loadAIImages(data.imageIds);
        });
      });
    }
  };

  const setAIPreference = () => {
    if(props.priors){
      if(priorStudyResponseData !== null){
        setIsHeatMapEnabled(priorStudyResponseData.heatMap);
        setIsOutlineEnabled(priorStudyResponseData.outline);
      }
    }else{
      if (studyResponseData != null) {
        setIsHeatMapEnabled(studyResponseData.heatMap);
        setIsOutlineEnabled(studyResponseData.outline);
      }
    }
  };

  useEffect(() => {
    if (
      thumbnailLoaded &&
      allowAddingTextAnnotation &&
      (SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST.includes(studyModality) ||
        (props.priors &&
          SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST.includes(studyModality))) &&
      imageLoadedOnViewport
    ) {
      setTimeout(() => {
        setAIPreference();
      }, 1500);
    }
  }, [thumbnailLoaded, allowAddingTextAnnotation, imageLoadedOnViewport, studyResponseData, priorStudyResponseData]);

  useEffect(() => {
    if (thumbnailLoaded && !isMobile && !sharedViewer) {
      fetchAIImages();
    }
  }, [thumbnailLoaded]);

  useEffect(() => {
    if (isMobile || getEnv("REACT_APP_VDC_PLATFORM") == "true") {
      setShowPathologyOptions(false);
    } else {
      if (
        roles.length != 0 &&
        (roles[0].includes(USERTYPES.FIRMDOCTOR) ||
          roles[0].includes(USERTYPES.FIRMTECHNICIAN)) &&
        !showAiResult
      ) {
        setShowPathologyOptions(false);
      } else {
        setShowPathologyOptions(true);
      }
    }
    if (
      roles.length !== 0 &&
      studyParentId !== null &&
      dataGathered &&
      isClientReportExist !== null
    ) {
      if (!roles[0].includes(USERTYPES.FIRMDOCTOR) || showSavedReport ) {
       
        if(NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER === window.location.pathname && firmViewerId !== null && firmViewerId !== -2){
          getData(false);
        }else if(NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER !== window.location.pathname){
          getData(false);
        }
      }
    }
  }, [roles, studyParentId, dataGathered, isClientReportExist, firmViewerId, showAiResult]);

  useEffect(() => {
    // if (!authenticated) {
    //   loadByUsername();
    // }
    // if(!cornerstoneInitialized) {
    //   initializeCornerstone();
    // }
    // if (props.priors) {
    //   getPriorStudyData();
    // } else {
    //   getStudyData();
    // }
    if (firmViewerId !== -1) {
      callAPIs();
    }
  }, [firmViewerId]);

  useEffect(() => {
    if (
      typeof patientStudyData?.patientName !== "undefined" &&
      patientStudyData?.patientName !== null
    )
      setDocumentTitle(getBrandedTitle(patientStudyData?.patientName));
  }, [patientStudyData]);

  useEffect(() => {
    if (documentTitle !== null) {
      document.title = documentTitle;
    }
  }, [documentTitle]);

  // Decide CPU vs GPU rendering for this study before viewports (and the
  // rendering engine) are created. Reconstructable modalities need the GPU so
  // MPR works; everything else stays on the safe CPU path on mobile.
  useEffect(() => {
    if (studyModality) {
      const reconstructable = CONSTRUCTABLE_MODALITIES.includes(studyModality);
      setPreferGpuRendering(reconstructable);
    }
  }, [studyModality]);

  useEffect(() => {
    if (LATERAL_VIEW_MODALITY_LIST.includes(studyModality) && !isMobile) {
      changeLayout(1, 2);
    }
  }, [studyModality]);

  const openReportMenu = () => {
    setReportMenu((prevFlag) => !prevFlag);
    // ResizeObserver in ViewportLayout tracks the container resize live
    // during the CSS panel transition and calls resizeViewport() each frame.
  };

  const openSeriesMenu = () => {
    // Close Report when opening Series
    setSlideReportOpen(false);
    setSeriesMenu(!seriesMenu);
    // ResizeObserver in ViewportLayout tracks the container resize live
    // during the CSS panel transition and calls resizeViewport() each frame.
  };

   useEffect(() => {
    // roles is still [] until userContext finishes loading; guard like the other roles[0] checks above
    if(roles.length !== 0 && !roles[0].includes(USERTYPES.FIRMTECHNICIAN)){
      if((autoOpenReportPanel && imageLoadedOnViewport) || (widgetOpen && imageLoadedOnViewport)) {
        openReportMenu();
        setSeriesMenu(false);
      } else if (imageLoadedOnViewport && !isMobile) {
        setSeriesMenu(true);
      }
    }
  }, [autoOpenReportPanel, imageLoadedOnViewport,widgetOpen,roles])



  useEffect(() => {
   

    // Debounce so that simultaneous `focus` + `visibilitychange` events (which
    // both fire when restoring from minimize/tab-switch) only trigger one resize.
    let resizeTimer = null;
    const scheduleResize = () => {
      if (!imageLoadedOnViewport) return;
      setIsTabFocused(true);
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        // Pass immediate=true so canvas dimensions are updated synchronously
        // before the render call, ensuring all viewport images stay visible.
        performResize(true);
        resizeTimer = null;
      }, 50);
    };

    const handleFocus = () => scheduleResize();
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        scheduleResize();
      }
    };
  
    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", handleVisibilityChange);
  
    return () => {
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      if (resizeTimer) clearTimeout(resizeTimer);
    };
  }, [imageLoadedOnViewport]);

  useEffect(() => {
    if (!showPathologyOptions) {
      setPathologyOptionOpened(false);
    } else {
      setTimeout(() => {
        setPathologyOptionOpened(true);
      }, 600);
    }
  }, [showPathologyOptions, cornerstoneInitialized, studyModality]);

  const onKeyPress = async (event) => {
    const { target, keyCode } = event;
    const currentViewportIndex = isMPRActive ? activeMPRViewportIndex : activeViewportIndex;

    const srcElement = event.srcElement || event.target;
    const isEditableTarget =
      srcElement?.isContentEditable ||
      srcElement?.nodeName === "INPUT" ||
      srcElement?.nodeName === "TEXTAREA" ||
      srcElement?.closest?.(
        '[contenteditable="true"], .fr-element, .fr-wrapper, .fr-box'
      );

    if (isEditableTarget) {
      return;
    }

    // event.preventDefault();
    if(target.nodeName!=='INPUT' && target.nodeName!=='TEXTAREA' && target.nodeName!='SELECT')
    {
      const isDeleteKey = keyCode === 46 || event.key === "Delete" || event.key === "Backspace";
      const isShiftD = (keyCode === 68 || event.key?.toLowerCase() === "d") && event.shiftKey;
      const hasPrimaryModifier = event.ctrlKey || event.metaKey;


      if (hasPrimaryModifier && isDeleteKey) { 
        event.preventDefault();
        removeAllMeasurements();
        return;
      }

      if (isDeleteKey || isShiftD) {
        event.preventDefault();
        removeSelectedMeasurement();
        return;
      }

      // Multi-frame playback shortcuts — Space, Home/End, +/− and (for
      // multi-frame viewports only) ←/→ for frame stepping. If the active
      // viewport isn't multi-frame this is a no-op and the switch below
      // handles the key as usual.
      if (handleMultiFrameShortcut(event, currentViewportIndex)) {
        event.preventDefault();
        return;
      }

      switch (keyCode) {
        case 27: //ESC
          if(isMPRActive) {
            setPreviousActiveMPRTool(activeMPRTool);
            handleDefaultToolChange();
          } else {
            setPreviousActiveTool(activeTool);
            handleDefaultToolChange();
          }
          break;
        case 73: //i -- INVERT
           setInvert(activeViewportIndex);
           break;
        case 72: //h -- HORIZONTAL FLIP
          FlipHorizontally(activeViewportIndex);
           break;
        case 86: //v -- VERTICAL FLIP
          FlipVertically(activeViewportIndex);
           break;
        case 48: //NORMAL WW WC
          //resetVOILUTRange(activeViewportIndex,initialVOIRange,isMPRActive);
          if (isMPRActive) {
            [0, 1, 2].forEach((viewportIndex) => {
              resetVOILUTRange(viewportIndex, initialVOIRange, true);
            });
          } else {
            resetVOILUTRange(activeViewportIndex, initialVOIRange, false);
          }
           break;
        case 49: //CT ABDOMEN
          setVOILUTRange(currentViewportIndex, 400, 60,false,isMPRActive);
           break;
        case 50: //CT ANGIO
          setVOILUTRange(currentViewportIndex, 600, 300,false,isMPRActive);
           break;
        case 51: //CT BONE
          setVOILUTRange(currentViewportIndex, 1500, 300,false,isMPRActive);
           break;
        case 52: //CT BRAIN
          setVOILUTRange(currentViewportIndex, 80, 40,false,isMPRActive);
            break;
        case 53: //CT CHEST
          setVOILUTRange(currentViewportIndex, 400, 40,false,isMPRActive);
            break;
        case 54: //CT LUNGS
          setVOILUTRange(currentViewportIndex, 1500, -400,false,isMPRActive);
            break;
        case 38: //UP
            event.preventDefault();
            // Mixed series: step INSTANCES even while a clip is on a frame.
            if (await stepMixedSeriesInstance(activeViewportIndex, -1)) break;
            const activeViewport1 = await getViewport(activeViewportIndex);
            const currentImage1 = activeViewport1.getCurrentImageIdIndex();
            
            if (currentImage1 !== 0) {
              activeViewport1.setImageIdIndex(currentImage1 - 1);
              activeViewport1.render();
            }
             break;
        case 40: //DOWN
            event.preventDefault();
            if (await stepMixedSeriesInstance(activeViewportIndex, +1)) break;
            const activeViewport2 = await getViewport(activeViewportIndex);
            const currentImage2 = activeViewport2.getCurrentImageIdIndex();
            if (currentImage2 !== viewportSeriesData[activeViewportIndex].stack.thumbnailImageIds.length - 1) {
              activeViewport2.setImageIdIndex(currentImage2 + 1);
              activeViewport2.render();
            }
            break;
        case 83:
            openSeriesMenu(); 
            if (!reportMenu && activeTool !== DEFAULT_TOOL) {
              setPreviousActiveTool(activeTool);
              setActiveTool(DEFAULT_TOOL);
              break;
          }
          break;
        case 82:
          if(event.target.nodeName!=='INPUT' && (!roles[0].includes(USERTYPES.FIRMDOCTOR) || showSavedReport) && (!roles[0].includes(USERTYPES.FIRMTECHNICIAN)))
            openReportMenu();
          break;
        case 39: //ARROW RIGHT
          event.preventDefault();
          if (!reportMenu) {
            if (activeThumbnailIndex === studyData?.stacks.length - 1) {
              break;
            }
            let activeThumbnailIndexNumber = Number(activeThumbnailIndex);
            setStackScrollActiveThumbnailIndex(activeThumbnailIndexNumber+1);
          }
          break;
        case 37: //ARROW LEFT
          event.preventDefault();
          if (!reportMenu) {
            if (activeThumbnailIndex === 0) {
              break;
            }
            setStackScrollActiveThumbnailIndex(activeThumbnailIndex - 1);
          }
          break;
        case 69: // 'e' for Elliptical
          // setActiveTool("EllipticalROI");
          // break;
          if (isMPRActive) {
            setPreviousActiveMPRTool(activeMPRTool);
            setActiveMPRTool("EllipticalROI");
            setToolOnActiveMPRViewport(
              activeMPRViewportIndex,
              "EllipticalROI",
              activeMPRTool,
              activeMPRViewportIndex,
              mouseButtonToolAssignments
            );
          } else {
            setPreviousActiveTool(activeTool);
            setActiveTool("EllipticalROI");
            setToolOnActiveViewport(
              activeViewportIndex,
              "EllipticalROI",
              activeTool,
              activeViewportIndex,
              mouseButtonToolAssignments
            );
          }
          break;

        case 76: // 'l' for Length
          event.preventDefault();
          if (isMPRActive) {
            setPreviousActiveMPRTool(activeMPRTool);
            setActiveMPRTool("Length");
            setToolOnActiveMPRViewport(
              activeMPRViewportIndex,
              "Length",
              activeMPRTool,
              activeMPRViewportIndex,
              mouseButtonToolAssignments
            );
          } else {
            setPreviousActiveTool(activeTool);
            setActiveTool("Length");
            setToolOnActiveViewport(
              activeViewportIndex,
              "Length",
              activeTool,
              activeViewportIndex,
              mouseButtonToolAssignments
            );
          }
          break;
        case 84: // 't' — Pan
          togglePrimaryMouseAssignmentForTool(PanTool.toolName);
          break;
        case 89: // 'y' — Stack scroll
          event.preventDefault();
          if (isMPRActive) {
            togglePrimaryMouseAssignmentForTool(StackScrollTool.toolName);
          } else {
            setPreviousActiveTool(activeTool);
            setActiveTool(StackScrollTool.toolName);
            setToolOnActiveViewport(
              activeViewportIndex,
              StackScrollTool.toolName,
              activeTool,
              activeViewportIndex
            );
            togglePrimaryMouseAssignmentForTool(StackScrollTool.toolName);
          }
          break;
        case 87: // 'w' — Window / window level
          event.preventDefault();
          if (isMPRActive) {
            togglePrimaryMouseAssignmentForTool(WindowLevelTool.toolName);
          } else {
            setPreviousActiveTool(activeTool);
            setActiveTool(WindowLevelTool.toolName);
            setToolOnActiveViewport(
              activeViewportIndex,
              WindowLevelTool.toolName,
              activeTool,
              activeViewportIndex
            );
            togglePrimaryMouseAssignmentForTool(WindowLevelTool.toolName);
          }
          break;
        case 90: // 'z' — Zoom (use mouse wheel or drag to zoom in/out)
          event.preventDefault();
          if (isMPRActive) {
            togglePrimaryMouseAssignmentForTool(ZoomTool.toolName);
          } else {
            setPreviousActiveTool(activeTool);
            setActiveTool(ZoomTool.toolName);
            setToolOnActiveViewport(activeViewportIndex, ZoomTool.toolName, activeTool, activeViewportIndex);
            togglePrimaryMouseAssignmentForTool(ZoomTool.toolName);
          }
          break;
        case 65: // 'a' — Angle (avoid Ctrl/Meta+A)
          if (!event.ctrlKey && !event.metaKey) {
            if (isMPRActive) {
              setPreviousActiveMPRTool(activeMPRTool);
              setActiveMPRTool(AngleTool.toolName);
              setToolOnActiveMPRViewport(
                activeMPRViewportIndex,
                AngleTool.toolName,
                activeMPRTool,
                activeMPRViewportIndex,
                mouseButtonToolAssignments
              );
            } else {
              setPreviousActiveTool(activeTool);
              setActiveTool(AngleTool.toolName);
              setToolOnActiveViewport(
                activeViewportIndex,
                AngleTool.toolName,
                activeTool,
                activeViewportIndex
              );
            }
          }
          break;
        case 88: // 'x' — Ctrl+Shift+X: save viewport as SC DICOM + append to report; plain 'c' (case 67): Cobb's angle
          if (event.ctrlKey && event.shiftKey) {
            event.preventDefault();
            window.dispatchEvent(
              new CustomEvent("aug:request-sc-capture", {
                detail: { viewportIndex: currentViewportIndex },
              })
            );
            break;
          }
          if (!event.ctrlKey && !event.metaKey) {
            if (isMPRActive) {
              setPreviousActiveMPRTool(activeMPRTool);
              setActiveMPRTool(CobbAngleTool.toolName);
              setToolOnActiveMPRViewport(
                activeMPRViewportIndex,
                CobbAngleTool.toolName,
                activeMPRTool,
                activeMPRViewportIndex,
                mouseButtonToolAssignments
              );
            } else {
              setPreviousActiveTool(activeTool);
              setActiveTool(CobbAngleTool.toolName);
              setToolOnActiveViewport(
                activeViewportIndex,
                CobbAngleTool.toolName,
                activeTool,
                activeViewportIndex
              );
            }
          }
          break;
        case 70: // 'f' for Image Enhancement Filters
          document.dispatchEvent(new CustomEvent("toggleImageEnhancement"));
          break;
        default:
          break;
      }
    }

  };




  useEffect(() => {
    window.addEventListener("keydown", onKeyPress);
    return () => {
      window.removeEventListener("keydown", onKeyPress);
    };
  });

  const initialViewportFocusedRef = useRef(false);
  useEffect(() => {
    if (isMobile || sharedViewer || !imageLoadedOnViewport) return;
    if (initialViewportFocusedRef.current) return;
    initialViewportFocusedRef.current = true;

    const focusActiveViewport = () => {
      const viewportEl = document.querySelector(
        `#viewport_${activeViewportIndex} #viewportEntry`
      );
      if (viewportEl) {
        viewportEl.tabIndex = 0;
        viewportEl.focus({ preventScroll: true });
      }
    };

    focusActiveViewport();
    const timer = setTimeout(focusActiveViewport, 1100);
    return () => clearTimeout(timer);
  }, [imageLoadedOnViewport, activeViewportIndex, isMobile, sharedViewer]);

  useEffect(() => {
    window.addEventListener("beforeunload", (e) => {
      // e.preventDefault();
      purgeCache();
    });

    return () => {
      window.removeEventListener("beforeunload", (e) => {
        // e.preventDefault();
        purgeCache();
      });
    };
  });

  const regenerateRSNA = (reportName) => {
    hideModal();
    if (reportName == "TUBERCULOSIS") {
      regenerateClick();
    }
  };

  const hideModal = () => {
    setOpenRSNAModal(false);
  };

  const checkForChildStudy = () => {
    if (
      activeStudyId !== "" &&
      studyParentId !== null &&
      studyParentId !== undefined
    ) {
      if (activeStudyId == studyParentId) {
        return false;
      } else {
        return true;
      }
    }
  };

  useEffect(() => {
    document.addEventListener("gesturestart", function (e) {
      e.preventDefault();
      // special hack to prevent zoom-to-tabs gesture in safari
      document.body.style.zoom = 0.99;
    });

    document.addEventListener("gesturechange", function (e) {
      e.preventDefault();
      // special hack to prevent zoom-to-tabs gesture in safari
      document.body.style.zoom = 0.99;
    });

    document.addEventListener("gestureend", function (e) {
      e.preventDefault();
      // special hack to prevent zoom-to-tabs gesture in safari
      document.body.style.zoom = 0.99;
    });
  }, []);

  return (
    <>
      {!isAccessAllowed && notAllowedMessage !== "" ? (
        <NotAllowed msg={notAllowedMessage} />
      ) : (
        <>
          {cornerstoneInitialized &&
            ((!props.priors && studyData.stacks.length !== 0) || true) && (
              <>
                {openRSNAModal && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0,
                      zIndex: 100000,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <RSNAModal
                      regenerateClick={regenerateRSNA}
                      hideModal={hideModal}
                      content={RSNAModalContent}
                      isModalOpen={openRSNAModal}
                    />
                  </div>
                )}
                {alertSuccessModal?.show && (
                  <AlertSuccessModal
                    isError={alertSuccessModal.isError}
                    isWarning={alertSuccessModal.isWarning}
                    isSuccess={alertSuccessModal.isSuccess}
                    heading={alertSuccessModal.heading}
                    description={alertSuccessModal.description}
                    hideModal={hideAlertSuccessModal}
                    isModalOpen={alertSuccessModal?.show}
                  />
                )}
                {confirmAlertModal?.show && (
                  <ConfirmAlertModal
                    isError={confirmAlertModal.isError}
                    heading={confirmAlertModal.heading}
                    isConflictPopup={confirmAlertModal.isConflictPopup}
                    description={confirmAlertModal.description}
                    hideModal={hideAlertSuccessModal}
                    isModalOpen={confirmAlertModal?.show}
                    type={confirmAlertModal.type}
                    lockStudy={lockStudy}
                    assignmentData={assignmentData}
                    checkIfCancelOrNot={checkIfCancelOrNot}
                    annotationData={annotationData}
                    annotationDataAI={annotationDataAI}
                    keyImages={keyImages}
                    activeViewportIndex={activeViewportIndex}
                    setConfirmAlertModal={setConfirmAlertModal}
                    allTextToolAnnotation={allTextToolAnnotation}
                    qcData={qcData}
                  />
                )}
                <AccountWarningModal
                  showModal={showAccountWarning}
                  hideModal={() => setShowAccountWarning(false)}
                  warningText={accountWarningText}
                />
                {
                  showShortcutModal && <ShortcutKeyModal isSharedStudyViewer={false}/>
                }
                <CalibrationModal />
                {showSuspectIcon && <SuspectIcon />}
                {showSubmitTick && <SubmitTick />}
                {showCommunicationModal && !isMobile && (
                  <CommunicationModal
                    isModalOpen={showCommunicationModal}
                    hideModal={hideCommnunicationModal}
                    studyParentId={studyParentId}
                    activeStudyId={activeStudyId}
                    child={checkForChildStudy()}
                    setMessageCount={setMessageCount}
                    studylist={false}
                  />
                )}
                {/* <button onClick={toast}>toast</button> */}
                {showTopBar && (
                  <TopBar
                    showPathologyOptions={showPathologyOptions}
                    setShowPathologyOptions={setShowPathologyOptions}
                    openReport={openReportMenu}
                    openSeries={openSeriesMenu}
                    seriesMenu={seriesMenu}
                    assignmentData={assignmentData}
                    priors={props.priors}
                  />
                )}
                {!isMobile && (
                  <div
                    id="viewport-div"
                    style={{
                      height: `${isMobile ? "85%" : viewportOldState.largeImage ? "calc(100% - var(--topbar-container-height, 7.5%))" : isLandscape ? "92.5%" : "calc(100% - var(--topbar-container-height, 90px))"}`,
                    }}
                  >
                    {(showPathologyForModalities.includes(studyModality) ||
                      showPriorStudyTopBar ||
                      // Keep the AI/pathology panel visible for the whole priors session
                      // (not just while an eligible study happens to be the active one) as
                      // long as the parent or ANY child study is an AI-eligible modality
                      // (CR/DX/RG/SC) - parentChildReportsObj holds every study in the
                      // group, keyed by study id.
                      Object.values(parentChildReportsObj || {}).some((study) =>
                        showPathologyForModalities.includes(study?.modality)
                      )) && (
                      // showPathologyOptions &&
                      <div
                        className={`viewport-pathology-container ${
                          showPathologyOptions ? "smart-tag-header" : ""
                        }`}
                        style={{
                          height: showPathologyOptions ? "10%" : "0px",
                          // background: theme.palette.viewerPathologyBackground,
                        }}
                      >
                        {showPathologyOptions && pathologyOptionOpened && (
                          <Annotations
                            reportOpen={reportMenu}
                            openReport={openReportMenu}
                            openSeries={openSeriesMenu}
                            priors={props.priors}
                          />
                        )}
                      </div>
                    )}
                    <div
                      className="viewer-thumbnail-section"
                      style={{
                        height: `${showPathologyOptions ? "92%" : "100%"}`,
                      }}
                      // onTouchStart={handleTouchStart}
                      // onTouchEnd={handleTouchEnd}
                    >
                      <div
                        style={{
                          height: "100%",
                          paddingBottom: "0",
                        }}
                        className={
                          `${
                            isMobile
                              ? "first-comes mobile-sidebar-left mobile-thumbnail-list"
                              : "first-comes sidebarMenu sidebar-left"
                          }` + (seriesMenu === true ? " sidebar-open-left" : "")
                            + (wideSeriesPanel ? " sidebar-left-wide" : "")
                        }
                      >
                        {/* {dataGathered && ( */}
                          <ThumbnailList
                            patientName={patientStudyData?.patientName}
                            patientId={patientStudyData?.patientId}
                            studyData={studyData}
                            priorStudyData={priorStudyData}
                            priors={props.priors}
                          />
                        {/* )} */}
                      </div>
                      <div
                        id="viewer-viewport-container"
                        className="viewer-viewport-container"
                        style={{
                          opacity: `${isMobile && seriesMenu ? "0.5" : 1}`,
                          // padding: `${isMobile ? "0" : "5px"}`,
                          width: `${
                            isMobile
                              ? "calc(100vw - 200px)"
                              : wideSeriesPanel
                                ? "calc(100vw - 230px)"
                                : "calc(100vw - 150px)"
                          }`,
                        }}
                      >
                        <Impressions />
                        <div
                          className={`viewer-viewport-section h100${!isLandscape ? ' portrait-report-layout' : ''}`}
                          style={{ flex: "1 1 auto", minHeight: 0 }}
                        >
                          <div
                            id="viewport-main-container"
                            className="main-container h100 w100"
                          >
                            <div
                              style={{
                                border: `${
                                  isMPRActive || isCompareActive
                                    ? "1px solid #FFB801"
                                    : ""
                                }`,
                                borderRadius: `${
                                  isMPRActive || isCompareActive ? "10px" : ""
                                }`,
                                width: `${isMobile ? "99.9%" : "99.5%"}`,
                                margin: "0px 0.25%",
                                height: `${viewportOldState.largeImage ? "100%" : "99.5%"}`,
                                position: "relative",
                              }}
                            >
                              {contextMenuOpen.open && (
                                <ContextMenu
                                  mouseEvt={contextMenuOpen.mouseEvt}
                                  data={contextMenuOpen.data}
                                />
                              )}
                              {/* {thumbnailLoaded && ( */}

                              <ViewportLayout priors={props.priors} initialVOI={setInitialVOIRange} />
                              {/* )} */}
                              {/* same AI disclaimer on mobile, with the
                                  same conditions as desktop above (XRay/RG main
                                  study, or priors with heatmap+outline). Desktop uses
                                  a 60em nowrap width that would truncate on a phone, so
                                  the mobile copy wraps, is smaller, and is pinned to the
                                  bottom of the viewport (below the image). */}
                              {isMobile &&
                                !isMPRActive &&
                                imageLoadedOnViewport &&
                                viewportSeriesData[activeViewportIndex]?.modality &&
                                (
                                  (props.priors &&
                                    NONXRAYMODALITIES.includes(viewportSeriesData[activeViewportIndex].modality) &&
                                    (viewportSeriesData[activeViewportIndex]?.heatmapStack?.imageIds?.length > 0 &&
                                      viewportSeriesData[activeViewportIndex]?.outlineStack?.imageIds?.length > 0)) ||
                                  (!props.priors && (NONXRAYMODALITIES.includes(viewportSeriesData[activeViewportIndex].modality) || viewportSeriesData[activeViewportIndex].modality === "RG"))
                                ) && (
                                  <div
                                    className="viewer-outline-heatmap-container"
                                    style={{ bottom: "2px", padding: "0 8px" }}
                                  >
                                    <span
                                      className="viewer-outline-heatmap-text"
                                      style={{
                                        fontSize: "9px",
                                        lineHeight: "11px",
                                        whiteSpace: "normal",
                                        textAlign: "center",
                                        width: "100%",
                                      }}
                                    >
                                      {t("string-literals.ai-disclaimer")}
                                    </span>
                                  </div>
                                )}
                              {isMPRActive && (
                                <div className="viewer-viewport-mpr-tag">
                                  {t("mpr.mpr-mode")}
                                </div>
                              )}
                              {isCompareActive && (
                                <div className="viewer-viewport-mpr-tag">
                                  {t("mpr.compare-mode")}
                                </div>
                              )}
                            </div>
                          </div>
                          {showStartAlertToast && <ViewerStartToast />}
                          <div
                            // style={{ height:  showPathologyOptions?window.innerHeight * 0.78:window.innerHeight * 0.88 }}
                            className={
                              `sidebarMenu sidebar-right modal-scroll` +
                              (reportMenu === true ? " sidebar-open" : "")
                            }
                          >
                            {/* <Report /> */}
                            <NewReport
                              modality={studyModality}
                              showPathologyOptions={showPathologyOptions}
                              customHeight={windowHeight}
                              qcData={qcData}
                              keyImages={keyImages}
                              annotationData={annotationData}
                              activeViewportIndex={activeViewportIndex}
                              assignmentData={assignmentData}
                              annotationDataAI={annotationDataAI}
                              allTextToolAnnotation={allTextToolAnnotation}
                              patientName={patientStudyData?.patientName}
                              patientId={patientStudyData?.patientId}
                              isStudyList={false}
                              parentChildReportsObj={parentChildReportsObj}
                              activeStudyId={activeStudyId}
                              studyParentId={studyParentId}
                              extReportReived={extReportRecieved}
                              showStudyExpirationPopup={
                                showStudyExpirationPopup
                              }
                              showStudyAlreadyExpiredPopup={
                                showStudyAlreadyExpiredPopup
                              }
                              firmId={firmViewerId}
                              reportMenu={reportMenu}
                            />
                          </div>
                        </div>
                        {!isMobile &&
                          !isMPRActive &&
                          imageLoadedOnViewport &&
                          viewportSeriesData[activeViewportIndex]?.modality &&
                          (
                            // Priors viewer: show only when both heatmap AND outline data are present in the active viewport
                            (props.priors &&
                              NONXRAYMODALITIES.includes(viewportSeriesData[activeViewportIndex].modality) &&
                              (viewportSeriesData[activeViewportIndex]?.heatmapStack?.imageIds?.length > 0 &&
                                viewportSeriesData[activeViewportIndex]?.outlineStack?.imageIds?.length > 0)) ||
                            // Main viewer - XRay studies only (CR, DX, RG), not MPR mode
                            (!props.priors && (NONXRAYMODALITIES.includes(viewportSeriesData[activeViewportIndex].modality) || viewportSeriesData[activeViewportIndex].modality === "RG"))
                          ) && (
                            <div className="viewer-outline-heatmap-container">
                              <span className="viewer-outline-heatmap-text viewer-outline-heatmap-text-width">
                                <CustomToolTipHost
                                  id="viewer-ai-text"
                                  content={t(
                                    "string-literals.ai-disclaimer"
                                  )}
                                >
                                  {t("string-literals.ai-disclaimer")}
                                </CustomToolTipHost>
                              </span>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                )}
                {isMobile && (
                  <Suspense fallback={null}>
                    <MobileViewer priors={props.priors} />
                  </Suspense>
                )}
              </>
            )}
        </>
      )}
    </>
  );
};

export default Viewer;
